var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('section',{staticClass:"q10__jumbotron"},[_c('image-with-descriptions',{staticClass:"mb-8 mt-0",attrs:{"options":{
                image:
                    'pages/' +
                    _vm.currentPage.slug +
                    '/' +
                    _vm.currentPage.images.imageJumbotron.src,
                descriptions: [
                    {
                        text: _vm.currentPage.images.imageJumbotron.edf,
                        position: 'bottom-right', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    } ],
            }}})],1),_c('div',{staticClass:"container px-11 2xl:px-3 mb-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                from: 'from-resolution_blue',
                to: 'to-dodger_blue',
            }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.mainTitle.text)}})]),_c('p',{staticClass:"font-bold text-tundora text-xl mb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.firstSubTitle.text)}}),_c('div',{staticClass:"container-components mb-4 lg:mb-8"},[_c('div',{staticClass:"card mt-0"},[_c('TitleParagraph',{attrs:{"options":{
                        from: 'from-resolution_blue',
                        to: 'to-dodger_blue',
                    }}},[_c('p',{staticClass:"text-xl lg:text-2xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.secondSubTitle.text)}})]),_c('paragraph',{attrs:{"options":{
                        color: 'text-nandor',
                    }}},[_c('span',{staticClass:"font-bold text-lg",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.firstParagraph.text)}})])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
                        from: 'from-resolution_blue',
                        to: 'to-dodger_blue',
                    }}},[_c('Triangles',{attrs:{"options":{
                            colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                            direction: 'top',
                        }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.firstTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
                        color: 'text-nandor',
                    }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.secondParagraph.text)}})])],1),_c('div',{staticClass:"card"},[_c('div',{staticClass:"relative w-full h-full"},[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image1.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image1
                                            .edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1),_c('div',{staticClass:"break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-resolution_blue',
                            to: 'to-dodger_blue',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'Desktop_left_Tablet_and_Mobile_top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.secondTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
                        color: 'text-nandor',
                    }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.thirdParagraph.text)}})])],1)])]),_c('div',{staticClass:"relative mb-4 lg:mb-8"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                    icon: 'diaporama',
                    collection: _vm.getRichmediaByCollection(
                        _vm.currentPage,
                        'Chantier La Coche Pelton 2015-2019'
                    ),
                }}}),_c('image-with-descriptions',{attrs:{"options":{
                    image:
                        'pages/' +
                        _vm.currentPage.slug +
                        '/' +
                        _vm.currentPage.images.image2.src,
                    descriptions: [
                        {
                            text: _vm.currentPage.images.image2.edf,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        } ],
                }}})],1),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
                        from: 'from-resolution_blue',
                        to: 'to-dodger_blue',
                    }}},[_c('Triangles',{attrs:{"options":{
                            colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                            direction: 'top',
                        }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.thirdSubTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
                        color: 'text-nandor',
                    }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.fourthParagraph.text)}})])],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                        from: 'from-resolution_blue',
                        to: 'to-dodger_blue',
                    }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.fifthSubTitle.text)}})]),_c('paragraph',{attrs:{"options":{
                        color: 'text-nandor',
                    }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sixthParagraph.text)}})])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
                        from: 'from-resolution_blue',
                        to: 'to-dodger_blue',
                    }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.fourthSubTitle.text)}})]),_c('paragraph',{attrs:{"options":{
                        color: 'text-nandor',
                    }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.fifthParagraph.text)}}),_c('Triangles',{attrs:{"options":{
                            colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                            direction: 'bottom',
                        }}})],1),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image3.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image3.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1)],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
                        from: 'from-resolution_blue',
                        to: 'to-dodger_blue',
                    }}},[_c('span',{staticClass:"text-xl lg:text-2xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.thirdTitle.text)}})]),_c('TitleParagraph',{attrs:{"options":{
                        from: 'from-resolution_blue',
                        to: 'to-dodger_blue',
                    }}},[_c('Triangles',{attrs:{"options":{
                            colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                            direction: 'bottom'
                        }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sixthSubTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
                        color: 'text-nandor',
                    }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.seventhParagraph.text)}})]),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image4.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image4.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1)],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
                        from: 'from-resolution_blue',
                        to: 'to-dodger_blue',
                    }}},[_c('Triangles',{attrs:{"options":{
                            colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                            direction: 'bottom',
                        }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.seventhSubTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
                        color: 'text-nandor',
                    }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.eigthParagraph.text)}})]),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image5.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image5.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1)],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }